"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var type_function_1 = require("./type-function");
var type_object_1 = require("./type-object");
exports.isPrimitive = function (value) {
    return value === null || (typeof value !== type_object_1.TYPE_OBJECT && typeof value !== type_function_1.TYPE_FUNCTION);
};
//# sourceMappingURL=is-primitive.js.map